// extracted by mini-css-extract-plugin
module.exports = {"resources":"Resources_resources__75Oe4"};